import { render, staticRenderFns } from "./product-attribute-selector-header.vue?vue&type=template&id=e8adff40&scoped=true"
import script from "./product-attribute-selector-header.vue?vue&type=script&lang=js"
export * from "./product-attribute-selector-header.vue?vue&type=script&lang=js"
import style0 from "./product-attribute-selector-header.vue?vue&type=style&index=0&id=e8adff40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8adff40",
  null
  
)

export default component.exports